import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import DsfMismatchFormContinueButton from "../../../../checkout/components/organisms/PersonalDetailsContinueButton/DsfMismatchFormContinueButton";
import * as VERIFICATION_SELECTORS from "../../../../checkout/state/selectors/verificationSelectors";
import TEXT from "../../../text-consts";

interface ConfirmNumberContinueButtonProps {
    canProductUserProceed: boolean;
    isDsfMismatch: boolean;
    url: string;
}

const ConfirmNumberContinueButton: React.FC<ConfirmNumberContinueButtonProps> = ({
    url,
    canProductUserProceed,
    isDsfMismatch,
}) => {
    if (isDsfMismatch) {
        return <DsfMismatchFormContinueButton />;
    }

    return (
        <Button
            onClick={() => window.location.assign(url)}
            id={`continue-button-${url}`}
            disabled={!canProductUserProceed}
        >
            {TEXT.COMMON.CONTINUE}
        </Button>
    );
};

const mapStateToProps = (state: RootState) => ({
    canProductUserProceed: VERIFICATION_SELECTORS.canProductUserProceed(state),
    isDsfMismatch: VERIFICATION_SELECTORS.isDsfMismatch(state),
});

export default connect(mapStateToProps)(ConfirmNumberContinueButton);
